export default {
      id: "ic_tribun_white-usage",
      viewBox: "0 0 30 18",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_white-usage",
      toString: function () {
        return this.url;
      }
    }